import { actionCreatorFactory } from "typescript-fsa";

import { WorkflowsActions } from "@com.mgmtp.a12.workflows/workflows-core/lib/actions";

const factory = actionCreatorFactory("MODULF");

/**
 * Action um ein Workflow Task Document zu öffnen
 */
export const customCompleteTask = factory<WorkflowsActions.CompleteTaskPayload>("COMPLETE_TASK");
